import request from '@/services/request';
import getError from '@/services/getError';

async function getSpr(api = '', name = '', year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/${api}`,
      method: 'get',
    });
    if (res.status === 200) {
      return { value: res.data, name: name };
    } else {
      throw new Error(name);
    }
  } catch (e) {
    await getError();
    throw new Error(name);
  }
}
async function getSprOrgForAdmin(year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/admin/orgblock`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data.sort((a, b) => a.id - b.id);
    } else {
      throw new Error('error getSprOrgForAdmin' + res);
    }
  } catch (e) {
    await getError();
    console.error('error getSprOrgForAdmin ' + e);
    throw new Error('error getSprOrgForAdmin ' + e);
  }
}
export { getSpr, getSprOrgForAdmin };
